// Miky Motorsport - definice tratí (control pointy pro spline generátor) + biomy (D)
// Každá trať: id, jméno, control pointy (clockwise), počet kol, biome (prostředí/nálada).
// POZN: zatáčky musí mít poloměr > ~18 m (bariéry jsou ~16 m od osy), jinak se AI zasekne.

export const TRACKS = {
  // Technický okruh v zeleném údolí - dlouhá rovinka, esíčka, vlásenka (à la Hungaroring).
  apex_ring: {
    id: 'apex_ring',
    name: 'Apex Ring',
    laps: 3,
    biome: 'meadow',
    ctrl: [
      [98, 0], [76, -28], [56, -47], [38, -67], [14, -80], [-16, -89],
      [-50, -86], [-68, -57], [-65, -24], [-70, 0], [-82, 30], [-72, 61],
      [-46, 79], [-15, 86], [14, 77], [34, 60], [61, 51], [93, 34],
    ],
  },
  // Rychlý pobřežní okruh - dlouhé sweepery + rychlá esíčka (à la Silverstone Maggotts).
  coastal_sweep: {
    id: 'coastal_sweep',
    name: 'Coastal Sweep',
    laps: 3,
    biome: 'coast',
    ctrl: [
      [129, 0], [106, -34], [78, -57], [56, -77], [30, -91], [0, -90],
      [-26, -80], [-54, -75], [-93, -67], [-125, -41], [-129, 0], [-106, 34],
      [-78, 57], [-56, 77], [-30, 91], [0, 90], [26, 80], [54, 75],
      [93, 67], [125, 41],
    ],
  },
  // Pouštní speedway - dlouhé rovinky, vlásenka a šikana (à la Bahrain mix).
  dune_speedway: {
    id: 'dune_speedway',
    name: 'Dune Speedway',
    laps: 3,
    biome: 'desert',
    ctrl: [
      [159, 0], [139, -45], [106, -77], [71, -98], [36, -110], [0, -115],
      [-36, -111], [-72, -99], [-107, -77], [-138, -45], [-157, 0], [-152, 49],
      [-120, 87], [-75, 103], [-33, 101], [0, 97], [33, 100], [74, 102],
      [120, 87], [153, 50],
    ],
  },
  // Noční městský okruh - technický, pravoúhlejší + šikana (à la Singapore/Monaco).
  neon_mile: {
    id: 'neon_mile',
    name: 'Neon Mile',
    laps: 3,
    biome: 'night',
    ctrl: [
      [114, 0], [86, -28], [67, -49], [57, -78], [33, -101], [0, -107],
      [-31, -95], [-50, -69], [-70, -51], [-105, -34], [-114, 0], [-86, 28],
      [-67, 49], [-57, 78], [-33, 101], [0, 107], [31, 95], [50, 69],
      [70, 51], [105, 34],
    ],
  },
  // --- Rozsireny set trati (H): vic tratí napríc biomy ---
  pine_valley: {
    id: 'pine_valley', name: 'Pine Valley', laps: 3, biome: 'meadow',
    ctrl: [[97, 0], [82, -27], [67, -48], [48, -67], [24, -74], [0, -73], [-23, -72], [-53, -73], [-86, -62], [-103, -33], [-97, 0], [-82, 27], [-67, 48], [-48, 67], [-24, 74], [0, 73], [23, 72], [53, 73], [86, 62], [103, 33]],
  },
  harbor_night: {
    id: 'harbor_night', name: 'Harbor Night', laps: 3, biome: 'night',
    ctrl: [[117, 0], [94, -28], [70, -45], [54, -62], [36, -79], [13, -91], [-14, -100], [-47, -104], [-75, -87], [-80, -51], [-71, -21], [-75, 0], [-90, 26], [-92, 59], [-72, 83], [-43, 95], [-14, 99], [13, 90], [32, 71], [51, 59], [81, 52], [113, 33]],
  },
  canyon_run: {
    id: 'canyon_run', name: 'Canyon Run', laps: 2, biome: 'desert',
    ctrl: [[150, 0], [130, -42], [101, -73], [69, -95], [35, -109], [0, -114], [-35, -108], [-69, -95], [-103, -75], [-135, -44], [-154, 0], [-148, 48], [-115, 83], [-70, 96], [-31, 95], [0, 94], [33, 101], [75, 104], [119, 87], [148, 48]],
  },
  bay_circuit: {
    id: 'bay_circuit', name: 'Bay Circuit', laps: 3, biome: 'coast',
    ctrl: [[131, 0], [103, -30], [81, -52], [65, -75], [43, -95], [15, -107], [-17, -119], [-56, -123], [-85, -98], [-87, -56], [-81, -24], [-93, 0], [-112, 33], [-108, 69], [-82, 94], [-50, 109], [-17, 115], [15, 103], [37, 81], [61, 71], [101, 65], [134, 39]],
  },
  highland_loop: {
    id: 'highland_loop', name: 'Highland Loop', laps: 3, biome: 'dawn',
    ctrl: [[105, 0], [80, -29], [55, -46], [42, -72], [18, -102], [-19, -108], [-48, -82], [-62, -52], [-76, -28], [-90, 0], [-92, 33], [-77, 64], [-49, 85], [-16, 90], [14, 80], [40, 69], [72, 60], [102, 37]],
  },
  speed_bowl: {
    id: 'speed_bowl', name: 'Speed Bowl', laps: 3, biome: 'desert',
    ctrl: [[173, 0], [148, -62], [102, -102], [52, -125], [0, -135], [-54, -130], [-105, -105], [-146, -61], [-167, 0], [-155, 64], [-110, 110], [-52, 126], [0, 125], [50, 121], [107, 107], [157, 65]],
  },
  twin_spire: {
    id: 'twin_spire', name: 'Twin Spire', laps: 3, biome: 'night',
    ctrl: [[117, 0], [90, -26], [72, -46], [62, -71], [43, -93], [16, -108], [-16, -111], [-40, -89], [-52, -60], [-76, -49], [-113, -33], [-117, 0], [-90, 26], [-72, 46], [-62, 71], [-43, 93], [-16, 108], [16, 111], [40, 89], [52, 60], [76, 49], [113, 33]],
  },
  autumn_ridge: {
    id: 'autumn_ridge', name: 'Autumn Ridge', laps: 3, biome: 'autumn',
    ctrl: [[107, 0], [86, -28], [68, -49], [51, -70], [27, -83], [0, -85], [-27, -82], [-58, -80], [-93, -68], [-113, -37], [-107, 0], [-86, 28], [-68, 49], [-51, 70], [-27, 83], [0, 85], [27, 82], [58, 80], [93, 68], [113, 37]],
  },
};

export const TRACK_ORDER = [
  'apex_ring', 'pine_valley', 'highland_loop', 'coastal_sweep', 'bay_circuit',
  'dune_speedway', 'canyon_run', 'speed_bowl', 'neon_mile', 'harbor_night',
  'twin_spire', 'autumn_ridge',
];
export const DEFAULT_TRACK = 'apex_ring';

export function getTrackDef(id) {
  return TRACKS[id] || TRACKS[DEFAULT_TRACK];
}

// Referencni cas kola (s) - zmerene letme kolo AI na zakladnim aute (veza_spark, D).
// Slouzi jako par pro casove medaile a denni vyzvu (cile = refLap × kola × nasobitel).
// Pri vyrazne zmene geometrie trati premerit (harness: AI sim-lap).
export const REF_LAP = {
  apex_ring: 28.3, pine_valley: 27.2, highland_loop: 28.6, coastal_sweep: 30.8,
  bay_circuit: 36.4, dune_speedway: 32.0, canyon_run: 31.8, speed_bowl: 33.1,
  neon_mile: 33.3, harbor_night: 32.1, twin_spire: 36.6, autumn_ridge: 28.3,
};
export function refLapOf(id) { return REF_LAP[id] || 30; }

// --- Biomy: prostředí/nálada (obloha, slunce, mlha, zem, scenérie) ---
// sunEl/sunAz = elevace/azimut slunce (st.). scenery = typ okolí. env = intenzita reflexí.
export const BIOMES = {
  meadow: {
    skyTop: 0x2c4488, skyBot: 0xf6b276, sun: 0xffdca6, sunInt: 2.6, sunEl: 30, sunAz: 135,
    fog: 0xe6c89e, fogNear: 240, fogFar: 760, ground: 0x3f4a3a,
    hemiSky: 0xd8c0a0, hemiGround: 0x53504a, hemiInt: 0.6, env: 0.9,
    scenery: 'forest', tree: 0x2f6b2f, hill: 0x4a5a64, elevAmp: 1.0,
  },
  coast: {
    skyTop: 0x1f6fb4, skyBot: 0xcfeaf0, sun: 0xfff2d8, sunInt: 2.9, sunEl: 48, sunAz: 150,
    fog: 0xcfe6ec, fogNear: 300, fogFar: 920, ground: 0x6f8f63,
    hemiSky: 0xbfe2ee, hemiGround: 0x5a6a52, hemiInt: 0.7, env: 1.0,
    scenery: 'coast', tree: 0x3c8a5a, hill: 0x6a86a0, elevAmp: 0.85,
  },
  desert: {
    skyTop: 0x3a78b0, skyBot: 0xeccf9c, sun: 0xfff0cf, sunInt: 3.1, sunEl: 58, sunAz: 110,
    fog: 0xe0c79a, fogNear: 340, fogFar: 1000, ground: 0xc3a36c,
    hemiSky: 0xd6e4f0, hemiGround: 0x9a7f55, hemiInt: 0.75, env: 1.05,
    scenery: 'desert', tree: 0x4f7d44, hill: 0xb08a5a, elevAmp: 1.2,
  },
  night: {
    skyTop: 0x070a18, skyBot: 0x2b3a66, sun: 0xaebcff, sunInt: 1.5, sunEl: 64, sunAz: 210,
    fog: 0x10172e, fogNear: 200, fogFar: 720, ground: 0x232838,
    hemiSky: 0x4a5a92, hemiGround: 0x12162a, hemiInt: 0.85, env: 0.8,
    scenery: 'city', tree: 0x223027, hill: 0x1c2440, elevAmp: 0.35,
  },
  dawn: { // svitani v horach - chladne ruzovo-modre nebe, nizke teple slunce
    skyTop: 0x1c2c58, skyBot: 0xe7a89e, sun: 0xffd6bc, sunInt: 2.2, sunEl: 16, sunAz: 95,
    fog: 0xdcc0bc, fogNear: 260, fogFar: 880, ground: 0x4a5848,
    hemiSky: 0xcdb8c8, hemiGround: 0x4a5048, hemiInt: 0.65, env: 0.85,
    scenery: 'forest', tree: 0x3a6a4a, hill: 0x6a7a92, elevAmp: 1.15,
  },
  autumn: { // podzimni les - tepla jantarova paleta, oranzove listi
    skyTop: 0x3a5070, skyBot: 0xe2b272, sun: 0xffd296, sunInt: 2.5, sunEl: 26, sunAz: 140,
    fog: 0xd8b888, fogNear: 240, fogFar: 800, ground: 0x6a5838,
    hemiSky: 0xd8c098, hemiGround: 0x5a4a38, hemiInt: 0.62, env: 0.9,
    scenery: 'forest', tree: 0xc2702a, hill: 0x8a6a4a, elevAmp: 1.0,
  },
};

export function getBiome(key) {
  return BIOMES[key] || BIOMES.meadow;
}
